import { useEffect, useState } from 'react';

/** Mirrors `value`, but only after it has stopped changing for `delay` ms. */
export const useDebouncedValue = (value, delay) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};
